import React, { Component } from 'react';
import { Line, Pie } from 'react-chartjs-2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';
import { Collapse } from 'react-collapse';
import Loader from 'react-loader-spinner';
import { ToastContainer, toast } from "react-toastify";

class DailyPerformanceData extends Component {

    constructor() {
        super();
        this.state = {
            displayKeyPerformanceByHour: true,
            selectedDate: new Date(),
            selectedKpiTagId: "",
            selectedKpiTagName: null,
            selectedKpiTotal: 0,
            todayKpiTagTotal: null,
            yesterdayKpiTagTotal: null,
            lastWeekKpiTagTotal: null,
            lastMonthKpiTagTotal: null,
            showLoader: false,

            keyPerformByHourData: {
                labels: [],
                datasets: [{
                    data: [],
                    label: "# of Conversations",
                    borderColor: "#3BA4DC",
                    pointColor: "#fff",
                    responsive: true,
                    pointStrokeColor: "#ccc",
                    pointHoverRadius: 10,
                    backgroundColor: ["rgba(60,167,224,0.4)"],
                    fill: true
                }]
            }
        }
    }

    componentDidMount() {
        var selectedDate = this.state.selectedDate;
        setTimeout(() => {
            this.fetchKpiInfoApi();
            this.fetchKeyPerformStatApi(selectedDate);
            this.fetchHistoricalDataByKpiTagApi(selectedDate);
            this.fetchTotalDataApi(selectedDate);
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            var selectedDate = thisController.state.selectedDate;
            thisController.projectId = event.projectId;
            thisController.fetchKpiInfoApi(event.projectId);
            thisController.fetchKeyPerformStatApi(selectedDate, event.projectId);
            thisController.fetchHistoricalDataByKpiTagApi(selectedDate, event.projectId);
            thisController.fetchTotalDataApi(selectedDate, event.projectId);
        });
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    fetchKeyPerformStatApi = (selectedDate, projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var DailyPerformController = this;
        var longDate = new Date(selectedDate.toDateString()).getTime();
        $.ajax({
            url: "/api/daily-kpi-tag-info-log-analytics",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                date: longDate,
                kpiTag: DailyPerformController.state.selectedKpiTagId,
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var dataSetDataAndLabel = DailyPerformController.setDailyConvLabels(res.result);
                    DailyPerformController.state.keyPerformByHourData["datasets"][0].data = dataSetDataAndLabel.datasetData
                    DailyPerformController.state.keyPerformByHourData["labels"] = dataSetDataAndLabel.labelData;
                    DailyPerformController.state.showLoader = true;
                    DailyPerformController.setState(DailyPerformController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    setDailyConvLabels = (data) => {
        var DailyPerformController = this;
        var labelData = [];
        var datasetData = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i].key < "12") {
                if (data[i].key == "00") {
                    labelData.push("12 AM - 1 AM");
                } else {
                    if (data[i].key == "11") {
                        labelData.push(Number(data[i].key) + " AM"
                            + " - " + (Number(data[i].key) + 1) + " PM");
                    } else {
                        labelData.push(Number(data[i].key) + " AM"
                            + " - " + (Number(data[i].key) + 1) + " AM");
                    }
                }
            } else {
                if (data[i].key == "12") {
                    labelData.push(Number(data[i].key) + " PM"
                        + " - " + ((Number(data[i].key) - 12) + 1) + " PM");
                } else {
                    if (data[i].key == "23") {
                        labelData.push((Number(data[i].key) - 12) + " PM"
                            + " - " + ((Number(data[i].key) - 12) + 1) + " AM");
                    } else {
                        labelData.push((Number(data[i].key) - 12) + " PM"
                            + " - " + ((Number(data[i].key) - 12) + 1) + " PM");
                    }
                }
            }
            datasetData.push(data[i].value);
        }
        return { "datasetData": datasetData, "labelData": labelData };

    }

    fetchKpiInfoApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var DailyPerformController = this;

        $.ajax({
            url: "/api/kpi-tag-info",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                if (res.success === true) {
                    var kpiOptionTag = document.getElementById("kpitag");
                    if (kpiOptionTag != "") {
                        if (kpiOptionTag != null) {
                            kpiOptionTag.innerHTML = '<option>Select KPI</option>';

                            for (var i = 0; i < res.result.length; i++) {
                                kpiOptionTag.innerHTML = kpiOptionTag.innerHTML + '<option value="' +
                                    res.result[i]["tagKey"] + '">' + res.result[i]["tagDisplayName"] + '</option>';
                            }
                            DailyPerformController.state.selectedKpiTagId = document.getElementById("kpitag").value;
                            DailyPerformController.state.selectedKpiTagName = kpiOptionTag.options[0].innerHTML;
                            DailyPerformController.state.showLoader = true;
                            DailyPerformController.setState(DailyPerformController.state);
                        }
                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchHistoricalDataByKpiTagApi = (selectedDate, projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var DailyPerformController = this;
        var longDate = new Date(selectedDate.toDateString()).getTime();
        $.ajax({
            url: "/api/historical-data-by-kpi-tag",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                date: longDate,
                kpiTag: DailyPerformController.state.selectedKpiTagId,
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                if (res.success === true) {
                    for (var i = 0; i < res.result.length; i++) {
                        DailyPerformController.state.todayKpiTagTotal = res.result[0].value;
                        DailyPerformController.state.yesterdayKpiTagTotal = res.result[1].value;
                        DailyPerformController.state.lastWeekKpiTagTotal = res.result[2].value;
                        DailyPerformController.state.lastMonthKpiTagTotal = res.result[3].value;
                    }
                    DailyPerformController.state.showLoader = true;
                    DailyPerformController.setState(DailyPerformController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchTotalDataApi = (selectedDate, projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var DailyPerformController = this;
        var longDate = new Date(selectedDate.toDateString()).getTime();
        $.ajax({
            url: "/api/daily-kpi-tag-info-log-total-by-tag-analytics",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                date: longDate,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                if (res.success === true) {
                    for (var i = 0; i < res.result.length; i++) {
                        if (res.result[i].key === DailyPerformController.state.selectedKpiTagName) {
                            DailyPerformController.state.selectedKpiTotal = res.result[i].value;
                            break;
                        }
                    }
                    DailyPerformController.state.showLoader = true;
                    DailyPerformController.setState(DailyPerformController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    onDateChange = (date) => {
        this.state.selectedDate = date;
        this.setState(this.state);
        this.fetchKpiInfoApi();
        this.fetchKeyPerformStatApi(date);
        this.fetchHistoricalDataByKpiTagApi(date);
        this.fetchTotalDataApi(date);
    }

    refreshData = (id) => {
        var selectedDate = this.state.selectedDate;
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchKpiInfoApi();
        this.fetchKeyPerformStatApi(selectedDate);
        this.fetchHistoricalDataByKpiTagApi(selectedDate);
        this.fetchTotalDataApi(selectedDate);
    }

    resetDate = () => {
        this.onDateChange(new Date());
    }

    displayKeyPerformanceByHour = () => {
        this.state.displayKeyPerformanceByHour ? this.setState({ displayKeyPerformanceByHour: false }) :
            this.setState({ displayKeyPerformanceByHour: true });
    }

    handleChangeKpiTagInfo = (e) => {
        var selectedDate = this.state.selectedDate;
        this.state.selectedKpiTagId = e.target.value;
        this.state.selectedKpiTagName = e.target.options[e.target.selectedIndex].innerHTML;
        this.fetchKeyPerformStatApi(selectedDate);
        this.fetchHistoricalDataByKpiTagApi(selectedDate);
        this.fetchTotalDataApi(selectedDate);
    }

    render() {
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!(this.state.showLoader)}
                    height={400}
                    width={50}
                    style={{ textAlign: 'center' }} />
                <div style={{ display: this.state.showLoader ? 'block' : 'none' }}>
                    {/* for toaster */}
                    <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />

                    <ToastContainer className="Toast-at-center" />

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6">
                                <h6 className="nav-item"
                                    style={{ color: '#282a65', marginTop: '10px', marginLeft: '7px' }}>
                                    Daily Performance Data
                                </h6>
                            </div>

                            <div className="d-flex flex-row-reverse pt-2 col-sm-6" style={{ backgroundColor: '#F9F9FB' }}>
                                <button className="btn action-button"
                                    style={{ marginTop: '6px' }}
                                    onClick={this.refreshData} title="Refresh">
                                    <img src="./assets/images/refresh_white_24dp.png" />
                                </button>

                                <button className="btn action-button"
                                    style={{ marginTop: '6px' }}
                                    onClick={this.resetDate}>Reset</button>
                                <DatePicker
                                    id="date"
                                    selected={this.state.selectedDate}
                                    onChange={this.onDateChange}
                                    dateFormat="dd/MM/yyyy">
                                </DatePicker>

                                <select className="input-group mb-3 form-control select2"
                                    style={{ width: '300px', marginRight: "20px", marginTop: "10px" }}
                                    value={this.state.selectedKpiTagId}
                                    name="kpitag" id="kpitag" onChange={this.handleChangeKpiTagInfo}>
                                    <option>Select KPI</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Main content */}
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12" style={{ marginLeft: "8px" }}>
                                    <label style={{ marginTop: '8px' }}>Aggregate</label>
                                    <div class="row mt-4 mb-4">
                                        <div style={{
                                            width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                                            textAlign: "center", borderRadius: "9px"
                                        }}><br />Today<br /><br /><div style={{ fontSize: "25px" }}>
                                                {this.state.todayKpiTagTotal}</div></div>

                                        <div style={{
                                            width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                                            textAlign: "center", marginLeft: "9px", borderRadius: "9px"
                                        }}><br />Yesterday<br /><br />
                                            <div style={{ fontSize: "25px" }}>{this.state.yesterdayKpiTagTotal}</div>
                                        </div>

                                        <div style={{
                                            width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                                            textAlign: "center", marginLeft: "9px", borderRadius: "9px"
                                        }}><br />Last 7 Days<br /><br />
                                            <div style={{ fontSize: "25px" }}>{this.state.lastWeekKpiTagTotal}</div>
                                        </div>

                                        <div style={{
                                            width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                                            textAlign: "center", marginLeft: "9px", borderRadius: "9px"
                                        }}><br />Last 30 Days<br /><br />
                                            <div style={{ fontSize: "25px" }}>{this.state.lastMonthKpiTagTotal}</div></div>
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <h6>
                                        <img src={this.state.displayKeyPerformanceByHour ? './assets/images/downward_arrow.png' :
                                            './assets/images/rightward_arrow.png'}
                                            onClick={this.displayKeyPerformanceByHour} />Key Performance By Hour<br /><br />
                                        <label>Total: {this.state.selectedKpiTotal}</label></h6>
                                    <Collapse isOpened={this.state.displayKeyPerformanceByHour}>

                                        <div className="card filled-line-chart">
                                            <div className="card-body">
                                                <div className="position-relative mb-4">
                                                    <Line data={this.state.keyPerformByHourData} width={1000} height={200} />
                                                </div>
                                            </div>
                                        </div>
                                    </Collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default DailyPerformanceData;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/statistics/dailyReports/DailyPerformData.js